module.exports = __webpack_public_path__ + "static/media/home-sample-1.8d418313.png";